import React from "react";
import DeleteIcon from "../assets/icons/delete-icon.svg";
import "../styles/components/requirement_item.css";

const RequirementItem = ({ requirement, index, onDelete }) => {
    return (
        <div className="requirement-item">
            <h3 className="requirement-item-title">
                {index}. {requirement}
            </h3>
            <div className="requirement-item-actions">
                <button
                    type="button"
                    className="requirement-item-btn"
                    onClick={() => onDelete(index)}
                >
                    <img src={DeleteIcon} alt="Delete" />
                </button>
            </div>
        </div>
    );
};

export default RequirementItem;